import apiInstance from "./api";

export const createResult = async (resultData) => {
	try {
		const res = await apiInstance.post("/results", {
			resultData,
		});
		return res;
	} catch (error) {
		console.error("Error creating result:", error);
	}
};

export const upsertResults = async (resultData) => {
	try {
		const res = await apiInstance.put("/results/bulk", {
			resultData,
		});
		return res;
	} catch (error) {
		console.error("Error updating results:", error);
	}
};

export const importResultsPdfPreview = async (formData) => {
	try {
		const res = await apiInstance.post("/results/import-pdf/preview", formData);
		return res.data;
	} catch (error) {
		console.error("Error importing results PDF:", error);
		throw error;
	}
};

export const getResults = async (event) => {
	try {
		const res = await apiInstance.get(`/results/${event}`);
		return res.data;
	} catch (error) {
		console.error("Error fetching results:", error);
	}
};

export const getOverallResults = async (sport, series, season) => {
	try {
		const res = await apiInstance.get(
			`/results/overall/${sport}/${series}/${season}`,
		);
		return res.data;
	} catch (error) {
		console.error("Error fetching overall results:", error);
	}
};

export const getResultsBySportAndSeries = async (sport, series, season) => {
	try {
		const res = await apiInstance.get(
			`/results/sport/${sport}/series/${series}/season/${season}`,
		);
		return res.data;
	} catch (error) {
		console.error("Error fetching results:", error);
	}
};

export const updateResults = async (eventId) => {
	try {
		const res = await apiInstance.put(`/results`, {
			eventId,
		});
		return res;
	} catch (error) {
		console.error("Error updating result:", error);
	}
};

export const getEventAnalytics = async (eventId) => {
	return apiInstance.get(`/results/mvp/${eventId}`);
};

export const getBestCountryForEvent = async (eventId) => {
	return apiInstance.get(`/results/event/${eventId}/country`);
};

export const getResultMVP = async (eventId) => {
	return apiInstance.get(`/results/event/${eventId}/mvp`);
};

export const getRiderHistory = async (riderId, params = {}) => {
	try {
		const res = await apiInstance.get(`/results/rider/${riderId}/history`, {
			params,
		});
		return res.data;
	} catch (error) {
		console.error("Error fetching rider history:", error);
		throw error;
	}
};
